define('kitpCreateEditLayoutView',[
  'module',
  'marionette',
  'backbone',
  'dialogFormView',
  'template!kitpCreateEditLayoutTpl',
  'savingBehavior',
  'bootbox',
  'underscore',
  'app',
  'settings',
  'autocompleteView'
], function(
  module,
  Marionette,
  Backbone,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  bootbox,
  _,
  App,
  Settings,
  AutocompleteView
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm'
    },

    regions: {
      selectMbAModel: '.js-select-mbamodel-region',
      selectMbAna: '.js-select-mbaana-region'
    },

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'algoresCh1', type: 'required'}
    ],

    initialize: function(options) {
      this.model = options.kitpModel.clone();
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function() {
      $.material.init();

      var mbAModelView = new AutocompleteView(
          this._getMbAModelsAutocompleteOptions('refMbAModel')
      );
      this.getRegion('selectMbAModel').show(mbAModelView);

      var mbAnaView = new AutocompleteView(
          this._getMbAnasAutocompleteOptions('refMbAna')
      );
      this.getRegion('selectMbAna').show(mbAnaView);

      this.triggerMethod('enable:cancel:confirm');
    },

    onConfirm: function() {
      if(this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    _getMbAnasAutocompleteOptions: function(property) {
      var mbAna = this.model.get(property);
      return {
        type: 'remote',
        remote: Settings.url('compuzz', 'v2/mbanas'),
        valueKey: 'code',
        apiKey: 'secId',
        placeholder: _.i18n('selectmbana.placeholder'),
        value: mbAna ? mbAna.code : null,
        name: property,
        onPressKey: true,
        lazyLoad: true,
        keys: {
          query: 'codeName',
          limit: 'pageSize'
        },
        callback: _.bind(this.onChangeMbAModel, this)
      };
    },

    _getMbAModelsAutocompleteOptions: function(property) {
      var mbAModel = this.model.get(property);
      return {
        type: 'remote',
        remote: Settings.url('compuzz', 'v2/mbamodels'),
        valueKey: 'code',
        apiKey: 'secId',
        placeholder: _.i18n('selectmbamodel.placeholder'),
        value: mbAModel ? mbAModel.code : null,
        name: property,
        onPressKey: true,
        lazyLoad: true,
        keys: {
          query: 'code',
          limit: 'pageSize'
        },
        callback: _.bind(this.onChangeMbAModel, this)
      };
    },

    onChangeMbAModel: function(fieldName, model) {
      if (model) {
        model.unset('autocompleteValue', {silent: true});
      }
      this.onChange(fieldName, model);
      this.triggerMethod('enable:cancel:confirm');
    },

    onSave: function(model) {
      var modelJSON = model.toJSON();
      this.options.kitpModel.set(modelJSON);
      this.triggerMethod('saved');
      App.trigger('kitps:header:rerender', modelJSON);
      this.hide();
    },

    hide: function() {
      var secId = this.model.get('secId');
      this.triggerMethod('hide');
      this.box.modal('hide');
      this.destroy();
      if (secId) {
          App.navigate('admin/kitp/'+secId, {trigger: true});
      }
    },

    onSaveError: function(model, response) {
      if(response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    },

    onDuplicateCode: function() {
      this.ui.endUserIdInput.popover('show');
      this.ui.endUserIdInput.addClass('invalid');
      this.ui.endUserIdInput.closest('div[data-field-name=code').addClass('has-error');
    }
  });

  module.exports = CreateEditLayoutView;
});
